import posthog from "posthog-js";

type DashboardAnalyticsEvent =
  | "dashboard_loaded"
  | "dashboard_tab_changed"
  | "owner_message_submitted"
  | "dashboard_api_request"
  | "dashboard_web_vital";

type AnalyticsProperties = Record<string, string | number | boolean | null | undefined>;

let initialized = false;

export function sanitizeAnalyticsProperties(properties: AnalyticsProperties = {}) {
  const sanitized: Record<string, string | number | boolean | null> = {};
  for (const [key, value] of Object.entries(properties)) {
    if (value === undefined) continue;
    if (/address|key|secret|token|account/i.test(key)) continue;
    sanitized[key] = value;
  }
  return sanitized;
}

export function initDashboardAnalytics() {
  const apiKey = import.meta.env.VITE_POSTHOG_KEY;
  if (!apiKey || initialized) return false;

  posthog.init(apiKey, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com",
    autocapture: false,
    capture_pageview: false,
    disable_session_recording: true,
    persistence: "localStorage+cookie",
    person_profiles: "identified_only",
  });
  initialized = true;
  return true;
}

export function captureDashboardEvent(
  event: DashboardAnalyticsEvent,
  properties: AnalyticsProperties = {},
) {
  if (!initialized) return false;
  posthog.capture(event, sanitizeAnalyticsProperties(properties));
  return true;
}
